webpackJsonp([162898551421021],{

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  header: {
	    textAlign: 'center',
	    padding: 10
	  }
	};
	
	var NotFoundPage = function NotFoundPage(_ref) {
	  var classes = _ref.classes;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _Typography2.default,
	      {
	        classes: { root: classes.header },
	        variant: 'title',
	        align: 'center'
	      },
	      'Page Not Found'
	    ),
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'body1', align: 'center' },
	      'That route does not exist. Please try elsewhere.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center', padding: 10 } },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Go to homepage'
	      )
	    )
	  );
	};
	
	NotFoundPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(NotFoundPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-c641a988f0a9bc110d73.js